import { useSelector } from 'react-redux';
import { Zone, ZoneName } from '../types/zones';
import { getInstallableModules, getZone, getZoneModules } from '../redux/selectors/zones';
import useGruser from './useGruser';
import { AppState } from '../types/store';
import { InstallableModule, Module } from '../types/modules';
import ZoneContext from '../context/ZoneContext/ZoneContext';
import { useContext } from 'react';

export const useZone = (zoneName: ZoneName): Zone => {
  const { gruser } = useGruser();
  return useSelector<any>(state => getZone(state, gruser, zoneName)) as Zone;
};

export const useCurrentZoneName = (): ZoneName | undefined => useContext(ZoneContext)?.name;

export const useZoneModules = (zoneName: ZoneName) => {
  const { gruser } = useGruser();
  const installedModules = useSelector<AppState, Module[]>(state =>
    getZoneModules(state, gruser, zoneName)
  );
  const installableModules = useSelector<AppState>(state =>
    getInstallableModules(state, gruser, zoneName)
  ) as InstallableModule[];

  return {
    installedModules,
    installableModules,
  };
};

export const useModuleInstallableToZone = (zoneName: ZoneName, moduleName) => {
  const { installedModules } = useZoneModules(zoneName);
  const { installableModuleTypes } = useZone(zoneName);
  const installedCount = installedModules.filter(m => m.name === moduleName).length;
  const installableCount =
    installableModuleTypes.find(m => m.moduleName === moduleName)?.restrict?.limit ||
    installedCount + 1;
  return installableCount > installedCount;
};

export default useZone;
